// @flow

const validateEmail = function(value: string): boolean {
  // eslint-disable-next-line no-useless-escape
  const emailExpr = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailExpr.test(value);
};

export default validateEmail;



// WEBPACK FOOTER //
// ./src/utils/validate-email.js